import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
  import { computed, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";

  import { formatDate } from "@/helpers/date";
  import router from "@/router";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EnquiriesREA',
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const enquiries = ref(props.userInfo.data);
  const userInfo = ref(props.userInfo);
  const listing = ref(null);
  const loading = ref(true);
  const listingIdToGo = ref(null);

  const onListing = () => {
    router.push({
      name: "ListingEdit",
      params: {
        listingId: listingIdToGo.value,
      },
    });
  };

  const getListing = async () => {
    loading.value = true;

    try {
      const { data } = await store.dispatch(
        "listing/getListing",
        props.userInfo.data.listing.uniqueId
      );

      listingIdToGo.value = data._id;
      listing.value = data;
      loading.value = false;
    } catch (error) {
      loading.value = false;
    }
  };

  const enquiryTitle = computed(() => {
    return `${userInfo.value.firstName} ${
      userInfo.value.lastName
    } has submitted an enquiry via ${userInfo.value.source.toLowerCase()}`;
  });

  onMounted(async () => {
    await getListing();
  });

const __returned__ = { props, enquiries, userInfo, listing, loading, listingIdToGo, onListing, getListing, enquiryTitle, get store() { return store }, computed, onMounted, ref, get useRoute() { return useRoute }, get formatDate() { return formatDate }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})